import { TableHeaderCustomContent } from 'cdk-radial';
import styled from 'styled-components';
import { Dropdown } from 'components/Dropdown';

export const StyledPrintDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledCIBDropdown = styled(Dropdown)`
  margin-right: 24px;
  width: 250px;
  display: inline-block;
`;

export const StyledDropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

export const StyledHeader = styled.div`
  position: relative;
  bottom: 100px;
  display: flex;
  gap: 10px;
`;

export const StyledTableHeaderCustomContent = styled(TableHeaderCustomContent)`
  display: flex;
  gap: 10px;
  border: none !important;
`;

export const StyledTableTitle = styled.div`
  font-family: Roboto, sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-top: 5px;
`;
